import { Button } from '@mui/material';
import { DEBUG, useConfigFirebase } from 'firebaseUtil';
import React from 'react'


export default function DebugObjComp({ colection, uidObj, values }) {    
    const inDebug = DEBUG
    if (!inDebug) {
        return ""
    }

    let srcFirestore = ""

    if (colection) {
        let idProjeto = useConfigFirebase.projectId
        srcFirestore = 'https://console.firebase.google.com/u/0/project/' + idProjeto + '/firestore/data/~2F' + (colection).replaceAll("/", '~2F')
        if (!srcFirestore.endsWith("~2F")) {
            srcFirestore = srcFirestore + "~2F"
        }
    }
    if (srcFirestore && (uidObj)) {
        srcFirestore += uidObj
    }

    return (
        <div style={{ position: 'fixed', bottom: 0 }}>

            {srcFirestore && <Button variant='contained' color='primary' onClick={() => {
                if (srcFirestore) {

                    window.open(srcFirestore, '_blank')
                }
            }}  >Ver Firebase</Button>}
            {values && <Button variant='contained' color='primary' onClick={() => {
                console.log('values', values)
            }}  >Console</Button>}
        </div>
    )
}
